var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLockAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#D8EEF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.698 29.708h-5.892v-5.156c0-6.001 5.023-10.886 11.196-10.886S43.2 18.551 43.2 24.552v5.156h-5.893v-5.156a5.085 5.085 0 00-1.554-3.646 5.381 5.381 0 00-3.75-1.51 5.381 5.381 0 00-3.75 1.51 5.085 5.085 0 00-1.553 3.646v5.156z",
    fill: "#01878E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.964 29.708H19.036c-.938 0-1.837.362-2.5 1.007a3.39 3.39 0 00-1.036 2.43v13.75a3.39 3.39 0 001.036 2.431 3.588 3.588 0 002.5 1.007h25.928c.938 0 1.837-.362 2.5-1.007a3.39 3.39 0 001.036-2.43v-13.75a3.39 3.39 0 00-1.036-2.431 3.588 3.588 0 00-2.5-1.007zm-10.018 11.96c0 .76-.31 1.488-.863 2.025a2.99 2.99 0 01-2.083.84 2.99 2.99 0 01-2.083-.84 2.825 2.825 0 01-.863-2.025V38.23c0-.76.31-1.488.863-2.025a2.99 2.99 0 012.083-.84c.781 0 1.53.302 2.083.84.553.537.863 1.265.863 2.025v3.438z",
    fill: "#01878E"
  })));
}

export default SvgLockAlt;